// modules are defined as an array
// [ module function, map of requires ]
//
// map of requires is short require name -> numeric require
//
// anything defined in a previous bundle is accessed via the
// orig method which is the require for previous bundles

(function (
  modules,
  entry,
  mainEntry,
  parcelRequireName,
  externals,
  distDir,
  publicUrl,
  devServer
) {
  /* eslint-disable no-undef */
  var globalObject =
    typeof globalThis !== 'undefined'
      ? globalThis
      : typeof self !== 'undefined'
      ? self
      : typeof window !== 'undefined'
      ? window
      : typeof global !== 'undefined'
      ? global
      : {};
  /* eslint-enable no-undef */

  // Save the require from previous bundle to this closure if any
  var previousRequire =
    typeof globalObject[parcelRequireName] === 'function' &&
    globalObject[parcelRequireName];

  var importMap = previousRequire.i || {};
  var cache = previousRequire.cache || {};
  // Do not use `require` to prevent Webpack from trying to bundle this call
  var nodeRequire =
    typeof module !== 'undefined' &&
    typeof module.require === 'function' &&
    module.require.bind(module);

  function newRequire(name, jumped) {
    if (!cache[name]) {
      if (!modules[name]) {
        if (externals[name]) {
          return externals[name];
        }
        // if we cannot find the module within our internal map or
        // cache jump to the current global require ie. the last bundle
        // that was added to the page.
        var currentRequire =
          typeof globalObject[parcelRequireName] === 'function' &&
          globalObject[parcelRequireName];
        if (!jumped && currentRequire) {
          return currentRequire(name, true);
        }

        // If there are other bundles on this page the require from the
        // previous one is saved to 'previousRequire'. Repeat this as
        // many times as there are bundles until the module is found or
        // we exhaust the require chain.
        if (previousRequire) {
          return previousRequire(name, true);
        }

        // Try the node require function if it exists.
        if (nodeRequire && typeof name === 'string') {
          return nodeRequire(name);
        }

        var err = new Error("Cannot find module '" + name + "'");
        err.code = 'MODULE_NOT_FOUND';
        throw err;
      }

      localRequire.resolve = resolve;
      localRequire.cache = {};

      var module = (cache[name] = new newRequire.Module(name));

      modules[name][0].call(
        module.exports,
        localRequire,
        module,
        module.exports,
        globalObject
      );
    }

    return cache[name].exports;

    function localRequire(x) {
      var res = localRequire.resolve(x);
      if (res === false) {
        return {};
      }
      // Synthesize a module to follow re-exports.
      if (Array.isArray(res)) {
        var m = {__esModule: true};
        res.forEach(function (v) {
          var key = v[0];
          var id = v[1];
          var exp = v[2] || v[0];
          var x = newRequire(id);
          if (key === '*') {
            Object.keys(x).forEach(function (key) {
              if (
                key === 'default' ||
                key === '__esModule' ||
                Object.prototype.hasOwnProperty.call(m, key)
              ) {
                return;
              }

              Object.defineProperty(m, key, {
                enumerable: true,
                get: function () {
                  return x[key];
                },
              });
            });
          } else if (exp === '*') {
            Object.defineProperty(m, key, {
              enumerable: true,
              value: x,
            });
          } else {
            Object.defineProperty(m, key, {
              enumerable: true,
              get: function () {
                if (exp === 'default') {
                  return x.__esModule ? x.default : x;
                }
                return x[exp];
              },
            });
          }
        });
        return m;
      }
      return newRequire(res);
    }

    function resolve(x) {
      var id = modules[name][1][x];
      return id != null ? id : x;
    }
  }

  function Module(moduleName) {
    this.id = moduleName;
    this.bundle = newRequire;
    this.require = nodeRequire;
    this.exports = {};
  }

  newRequire.isParcelRequire = true;
  newRequire.Module = Module;
  newRequire.modules = modules;
  newRequire.cache = cache;
  newRequire.parent = previousRequire;
  newRequire.distDir = distDir;
  newRequire.publicUrl = publicUrl;
  newRequire.devServer = devServer;
  newRequire.i = importMap;
  newRequire.register = function (id, exports) {
    modules[id] = [
      function (require, module) {
        module.exports = exports;
      },
      {},
    ];
  };

  // Only insert newRequire.load when it is actually used.
  // The code in this file is linted against ES5, so dynamic import is not allowed.
  // INSERT_LOAD_HERE

  Object.defineProperty(newRequire, 'root', {
    get: function () {
      return globalObject[parcelRequireName];
    },
  });

  globalObject[parcelRequireName] = newRequire;

  for (var i = 0; i < entry.length; i++) {
    newRequire(entry[i]);
  }

  if (mainEntry) {
    // Expose entry point to Node, AMD or browser globals
    // Based on https://github.com/ForbesLindesay/umd/blob/master/template.js
    var mainExports = newRequire(mainEntry);

    // CommonJS
    if (typeof exports === 'object' && typeof module !== 'undefined') {
      module.exports = mainExports;

      // RequireJS
    } else if (typeof define === 'function' && define.amd) {
      define(function () {
        return mainExports;
      });
    }
  }
})({"a8OVv":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _tagGroup = require("vanilla-starter/TagGroup");
"use client";
exports.default = /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _tagGroup.TagGroup), {
    children: [
        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _tagGroup.Tag), {
            children: "News"
        }),
        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _tagGroup.Tag), {
            children: "Travel"
        }),
        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _tagGroup.Tag), {
            children: "Gaming"
        }),
        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _tagGroup.Tag), {
            children: "Shopping"
        })
    ]
});

},{"react/jsx-runtime":"2Is6Z","vanilla-starter/TagGroup":"eq0FG","@parcel/transformer-js/src/esmodule-helpers.js":"3OmcS"}],"eq0FG":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "TagGroup", ()=>TagGroup);
parcelHelpers.export(exports, "Tag", ()=>Tag);
var _jsxRuntime = require("react/jsx-runtime");
var _reactAriaComponents = require("react-aria-components");
var _form = require("./Form");
var _content = require("./Content");
var _lucideReact = require("lucide-react");
var _tagGroupCss = require("./TagGroup.css");
'use client';
function TagGroup({ label, description, errorMessage, items, children, renderEmptyState, ...props }) {
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _reactAriaComponents.TagGroup), {
        ...props,
        children: [
            label && /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _form.Label), {
                children: label
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactAriaComponents.TagList), {
                items: items,
                renderEmptyState: renderEmptyState,
                children: children
            }),
            description && /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _form.Description), {
                children: description
            }),
            errorMessage && /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _content.Text), {
                slot: "errorMessage",
                children: errorMessage
            })
        ]
    });
}
function Tag({ children, ...props }) {
    let textValue = typeof children === 'string' ? children : undefined;
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactAriaComponents.Tag), {
        textValue: textValue,
        ...props,
        className: "react-aria-Tag button-base",
        children: ({ allowsRemoving })=>/*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _jsxRuntime.Fragment), {
                children: [
                    children,
                    allowsRemoving && /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactAriaComponents.Button), {
                        slot: "remove",
                        className: "remove-button",
                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _lucideReact.X), {})
                    })
                ]
            })
    });
}

},{"react/jsx-runtime":"2Is6Z","react-aria-components":[["Button","9G5XO"],["Tag","dIN55"],["TagGroup","dIN55"],["TagList","dIN55"]],"./Form":"6qejZ","./Content":"jYtLe","lucide-react":[["X","1gkBb","default"]],"./TagGroup.css":"72EEe","@parcel/transformer-js/src/esmodule-helpers.js":"3OmcS"}],"6qejZ":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "Form", ()=>Form);
parcelHelpers.export(exports, "Label", ()=>Label);
parcelHelpers.export(exports, "FieldError", ()=>FieldError);
parcelHelpers.export(exports, "Description", ()=>Description);
parcelHelpers.export(exports, "FieldButton", ()=>FieldButton);
var _jsxRuntime = require("react/jsx-runtime");
var _reactAriaComponents = require("react-aria-components");
var _formCss = require("./Form.css");
var _content = require("./Content");
'use client';
function Form(props) {
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactAriaComponents.Form), {
        ...props
    });
}
function Label(props) {
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactAriaComponents.Label), {
        ...props
    });
}
function FieldError(props) {
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactAriaComponents.FieldError), {
        ...props
    });
}
function Description(props) {
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _content.Text), {
        slot: "description",
        className: "field-description",
        ...props
    });
}
function FieldButton(props) {
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactAriaComponents.Button), {
        ...props,
        className: "field-Button"
    });
}

},{"react/jsx-runtime":"2Is6Z","react-aria-components":[["Button","9G5XO"],["FieldError","algyu"],["Form","g7RKA"],["Label","fjKq6"]],"./Form.css":"7sxTy","./Content":"jYtLe","@parcel/transformer-js/src/esmodule-helpers.js":"3OmcS"}],"7sxTy":[function() {},{}],"jYtLe":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "Heading", ()=>Heading);
parcelHelpers.export(exports, "Text", ()=>Text);
var _jsxRuntime = require("react/jsx-runtime");
var _reactAriaComponents = require("react-aria-components");
var _contentCss = require("./Content.css");
function Heading(props) {
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactAriaComponents.Heading), {
        ...props
    });
}
function Text(props) {
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactAriaComponents.Text), {
        ...props
    });
}

},{"react/jsx-runtime":"2Is6Z","react-aria-components":[["Heading","2f4nH"],["Text","jt9fm"]],"./Content.css":"kvyv3","@parcel/transformer-js/src/esmodule-helpers.js":"3OmcS"}],"kvyv3":[function() {},{}],"1gkBb":[function(require,module,exports,__globalThis) {
/**
 * @license lucide-react v0.517.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "__iconNode", ()=>__iconNode);
parcelHelpers.export(exports, "default", ()=>X);
var _createLucideIconJs = require("../createLucideIcon.js");
var _createLucideIconJsDefault = parcelHelpers.interopDefault(_createLucideIconJs);
const __iconNode = [
    [
        "path",
        {
            d: "M18 6 6 18",
            key: "1bl5f8"
        }
    ],
    [
        "path",
        {
            d: "m6 6 12 12",
            key: "d8bk6v"
        }
    ]
];
const X = (0, _createLucideIconJsDefault.default)("x", __iconNode);

},{"../createLucideIcon.js":"gsSty","@parcel/transformer-js/src/esmodule-helpers.js":"3OmcS"}],"gsSty":[function(require,module,exports,__globalThis) {
/**
 * @license lucide-react v0.517.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>createLucideIcon);
var _react = require("react");
var _utilsJs = require("./shared/src/utils.js");
var _iconJs = require("./Icon.js");
var _iconJsDefault = parcelHelpers.interopDefault(_iconJs);
const createLucideIcon = (iconName, iconNode)=>{
    const Component = (0, _react.forwardRef)(({ className, ...props }, ref)=>(0, _react.createElement)((0, _iconJsDefault.default), {
            ref,
            iconNode,
            className: (0, _utilsJs.mergeClasses)(`lucide-${(0, _utilsJs.toKebabCase)((0, _utilsJs.toPascalCase)(iconName))}`, `lucide-${iconName}`, className),
            ...props
        }));
    Component.displayName = (0, _utilsJs.toPascalCase)(iconName);
    return Component;
};

},{"react":"a1TxN","./shared/src/utils.js":"lfP1m","./Icon.js":"d0fsO","@parcel/transformer-js/src/esmodule-helpers.js":"3OmcS"}],"lfP1m":[function(require,module,exports,__globalThis) {
/**
 * @license lucide-react v0.517.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "hasA11yProp", ()=>hasA11yProp);
parcelHelpers.export(exports, "mergeClasses", ()=>mergeClasses);
parcelHelpers.export(exports, "toCamelCase", ()=>toCamelCase);
parcelHelpers.export(exports, "toKebabCase", ()=>toKebabCase);
parcelHelpers.export(exports, "toPascalCase", ()=>toPascalCase);
const toKebabCase = (string)=>string.replace(/([a-z0-9])([A-Z])/g, "$1-$2").toLowerCase();
const toCamelCase = (string)=>string.replace(/^([A-Z])|[\s-_]+(\w)/g, (match, p1, p2)=>p2 ? p2.toUpperCase() : p1.toLowerCase());
const toPascalCase = (string)=>{
    const camelCase = toCamelCase(string);
    return camelCase.charAt(0).toUpperCase() + camelCase.slice(1);
};
const mergeClasses = (...classes)=>classes.filter((className, index, array)=>{
        return Boolean(className) && className.trim() !== "" && array.indexOf(className) === index;
    }).join(" ").trim();
const hasA11yProp = (props)=>{
    for(const prop in props){
        if (prop.startsWith("aria-") || prop === "role" || prop === "title") return true;
    }
};

},{"@parcel/transformer-js/src/esmodule-helpers.js":"3OmcS"}],"d0fsO":[function(require,module,exports,__globalThis) {
/**
 * @license lucide-react v0.517.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>Icon);
var _react = require("react");
var _defaultAttributesJs = require("./defaultAttributes.js");
var _defaultAttributesJsDefault = parcelHelpers.interopDefault(_defaultAttributesJs);
var _utilsJs = require("./shared/src/utils.js");
const Icon = (0, _react.forwardRef)(({ color = "currentColor", size = 24, strokeWidth = 2, absoluteStrokeWidth, className = "", children, iconNode, ...rest }, ref)=>(0, _react.createElement)("svg", {
        ref,
        ...(0, _defaultAttributesJsDefault.default),
        width: size,
        height: size,
        stroke: color,
        strokeWidth: absoluteStrokeWidth ? Number(strokeWidth) * 24 / Number(size) : strokeWidth,
        className: (0, _utilsJs.mergeClasses)("lucide", className),
        ...!children && !(0, _utilsJs.hasA11yProp)(rest) && {
            "aria-hidden": "true"
        },
        ...rest
    }, [
        ...iconNode.map(([tag, attrs])=>(0, _react.createElement)(tag, attrs)),
        ...Array.isArray(children) ? children : [
            children
        ]
    ]));

},{"react":"a1TxN","./defaultAttributes.js":"9Rm8m","./shared/src/utils.js":"lfP1m","@parcel/transformer-js/src/esmodule-helpers.js":"3OmcS"}],"9Rm8m":[function(require,module,exports,__globalThis) {
/**
 * @license lucide-react v0.517.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>defaultAttributes);
var defaultAttributes = {
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    stroke: "currentColor",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
};

},{"@parcel/transformer-js/src/esmodule-helpers.js":"3OmcS"}],"72EEe":[function() {},{}],"cEydW":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _tagGroup = require("tailwind-starter/TagGroup");
"use client";
exports.default = /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _tagGroup.TagGroup), {
    children: [
        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _tagGroup.Tag), {
            children: "News"
        }),
        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _tagGroup.Tag), {
            children: "Travel"
        }),
        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _tagGroup.Tag), {
            children: "Gaming"
        }),
        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _tagGroup.Tag), {
            children: "Shopping"
        })
    ]
});

},{"react/jsx-runtime":"2Is6Z","tailwind-starter/TagGroup":"9wXZT","@parcel/transformer-js/src/esmodule-helpers.js":"3OmcS"}],"9wXZT":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "TagGroup", ()=>TagGroup);
parcelHelpers.export(exports, "Tag", ()=>Tag);
var _jsxRuntime = require("react/jsx-runtime");
var _lucideReact = require("lucide-react");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _reactAriaComponents = require("react-aria-components");
var _tailwindMerge = require("tailwind-merge");
var _tailwindVariants = require("tailwind-variants");
var _field = require("./Field");
var _utils = require("./utils");
'use client';
const colors = {
    gray: 'bg-white text-gray-600 border-gray-200 hover:border-gray-300 dark:bg-zinc-900 dark:text-zinc-300 dark:border-zinc-600 dark:hover:border-zinc-500',
    green: 'bg-green-100 text-green-700 border-green-200 hover:border-green-300 dark:bg-green-300/20 dark:text-green-400 dark:border-green-300/10 dark:hover:border-green-300/20',
    yellow: 'bg-yellow-100 text-yellow-700 border-yellow-200 hover:border-yellow-300 dark:bg-yellow-300/20 dark:text-yellow-400 dark:border-yellow-300/10 dark:hover:border-yellow-300/20',
    blue: 'bg-blue-100 text-blue-700 border-blue-200 hover:border-blue-300 dark:bg-blue-400/20 dark:text-blue-300 dark:border-blue-400/10 dark:hover:border-blue-400/20'
};
const ColorContext = /*#__PURE__*/ (0, _react.createContext)('gray');
const tagStyles = (0, _tailwindVariants.tv)({
    extend: (0, _utils.focusRing),
    base: 'transition cursor-default text-xs rounded-full border px-3 py-0.5 flex items-center max-w-fit gap-1 font-sans',
    variants: {
        color: {
            gray: '',
            green: '',
            yellow: '',
            blue: ''
        },
        allowsRemoving: {
            true: 'pr-1'
        },
        isSelected: {
            true: 'bg-blue-600 text-white border-transparent forced-colors:bg-[Highlight] forced-colors:text-[HighlightText] forced-color-adjust-none'
        },
        isDisabled: {
            true: 'bg-gray-100 dark:bg-transparent dark:border-white/20 text-gray-300 dark:text-zinc-600 forced-colors:text-[GrayText]'
        }
    },
    compoundVariants: Object.keys(colors).map((color)=>({
            isSelected: false,
            isDisabled: false,
            color,
            class: colors[color]
        }))
});
function TagGroup({ label, description, errorMessage, items, children, renderEmptyState, ...props }) {
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _reactAriaComponents.TagGroup), {
        ...props,
        className: (0, _tailwindMerge.twMerge)('flex flex-col gap-2 font-sans', props.className),
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _field.Label), {
                children: label
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)(ColorContext.Provider, {
                value: props.color || 'gray',
                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactAriaComponents.TagList), {
                    items: items,
                    renderEmptyState: renderEmptyState,
                    className: "flex flex-wrap gap-1",
                    children: children
                })
            }),
            description && /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _field.Description), {
                children: description
            }),
            errorMessage && /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactAriaComponents.Text), {
                slot: "errorMessage",
                className: "text-sm text-red-600",
                children: errorMessage
            })
        ]
    });
}
const removeButtonStyles = (0, _tailwindVariants.tv)({
    extend: (0, _utils.focusRing),
    base: 'cursor-default rounded-full transition-[background-color] p-0.5 flex items-center justify-center hover:bg-black/10 dark:hover:bg-white/10 pressed:bg-black/20 dark:pressed:bg-white/20'
});
function Tag({ children, color, ...props }) {
    let textValue = typeof children === 'string' ? children : undefined;
    let groupColor = (0, _react.useContext)(ColorContext);
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactAriaComponents.Tag), {
        textValue: textValue,
        ...props,
        className: (0, _reactAriaComponents.composeRenderProps)(props.className, (className, renderProps)=>tagStyles({
                ...renderProps,
                className,
                color: color || groupColor
            })),
        children: (0, _reactAriaComponents.composeRenderProps)(children, (children, { allowsRemoving })=>/*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _jsxRuntime.Fragment), {
                children: [
                    children,
                    allowsRemoving && /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactAriaComponents.Button), {
                        slot: "remove",
                        className: removeButtonStyles,
                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _lucideReact.XIcon), {
                            "aria-hidden": true,
                            className: "w-3 h-3"
                        })
                    })
                ]
            }))
    });
}

},{"react/jsx-runtime":"2Is6Z","lucide-react":[["XIcon","1gkBb","default"]],"react":"a1TxN","react-aria-components":[["Button","9G5XO"],["composeRenderProps","bA6Cz"],["Tag","dIN55"],["TagGroup","dIN55"],["TagList","dIN55"],["Text","jt9fm"]],"tailwind-merge":"lEVAz","tailwind-variants":"dpXBU","./Field":"5fXWs","./utils":"jNXji","@parcel/transformer-js/src/esmodule-helpers.js":"3OmcS"}],"5fXWs":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "Label", ()=>Label);
parcelHelpers.export(exports, "Description", ()=>Description);
parcelHelpers.export(exports, "FieldError", ()=>FieldError);
parcelHelpers.export(exports, "fieldBorderStyles", ()=>fieldBorderStyles);
parcelHelpers.export(exports, "fieldGroupStyles", ()=>fieldGroupStyles);
parcelHelpers.export(exports, "FieldGroup", ()=>FieldGroup);
parcelHelpers.export(exports, "Input", ()=>Input);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _reactAriaComponents = require("react-aria-components");
var _tailwindMerge = require("tailwind-merge");
var _tailwindVariants = require("tailwind-variants");
var _utils = require("./utils");
'use client';
function Label(props) {
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactAriaComponents.Label), {
        ...props,
        className: (0, _tailwindMerge.twMerge)('text-sm text-gray-600 dark:text-zinc-400 font-medium cursor-default w-fit', props.className)
    });
}
function Description(props) {
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactAriaComponents.Text), {
        ...props,
        slot: "description",
        className: (0, _tailwindMerge.twMerge)('text-sm text-gray-600', props.className)
    });
}
function FieldError(props) {
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactAriaComponents.FieldError), {
        ...props,
        className: (0, _utils.composeTailwindRenderProps)(props.className, 'text-sm text-red-600 forced-colors:text-[Mark]')
    });
}
const fieldBorderStyles = (0, _tailwindVariants.tv)({
    variants: {
        isFocusWithin: {
            false: 'border-gray-300 dark:border-zinc-500 forced-colors:border-[ButtonBorder]',
            true: 'border-gray-600 dark:border-zinc-300 forced-colors:border-[Highlight]'
        },
        isInvalid: {
            true: 'border-red-600 dark:border-red-600 forced-colors:border-[Mark]'
        },
        isDisabled: {
            true: 'border-gray-200 dark:border-zinc-700 forced-colors:border-[GrayText]'
        }
    }
});
const fieldGroupStyles = (0, _tailwindVariants.tv)({
    extend: (0, _utils.focusRing),
    base: 'group flex items-center h-9 box-border bg-white dark:bg-zinc-900 forced-colors:bg-[Field] border-2 rounded-lg overflow-hidden',
    variants: fieldBorderStyles.variants
});
function FieldGroup(props) {
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactAriaComponents.Group), {
        ...props,
        className: (0, _reactAriaComponents.composeRenderProps)(props.className, (className, renderProps)=>fieldGroupStyles({
                ...renderProps,
                className
            }))
    });
}
function Input(props) {
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactAriaComponents.Input), {
        ...props,
        className: (0, _utils.composeTailwindRenderProps)(props.className, 'px-2 py-1.5 flex-1 min-w-0 border-0 outline outline-0 bg-white dark:bg-zinc-900 text-sm text-gray-800 dark:text-zinc-200 disabled:text-gray-200 dark:disabled:text-zinc-600')
    });
}

},{"react/jsx-runtime":"2Is6Z","react":"a1TxN","react-aria-components":[["composeRenderProps","bA6Cz"],["FieldError","algyu"],["Group","6UspO"],["Input","jU9y1"],["Label","fjKq6"],["Text","jt9fm"]],"tailwind-merge":"lEVAz","tailwind-variants":"dpXBU","./utils":"jNXji","@parcel/transformer-js/src/esmodule-helpers.js":"3OmcS"}],"jNXji":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "focusRing", ()=>focusRing);
parcelHelpers.export(exports, "composeTailwindRenderProps", ()=>composeTailwindRenderProps);
var _reactAriaComponents = require("react-aria-components");
var _tailwindMerge = require("tailwind-merge");
var _tailwindVariants = require("tailwind-variants");
const focusRing = (0, _tailwindVariants.tv)({
    base: 'outline outline-blue-600 dark:outline-blue-500 forced-colors:outline-[Highlight] outline-offset-2',
    variants: {
        isFocusVisible: {
            false: 'outline-0',
            true: 'outline-2'
        }
    }
});
function composeTailwindRenderProps(className, tw) {
    return (0, _reactAriaComponents.composeRenderProps)(className, (className)=>(0, _tailwindMerge.twMerge)(tw, className));
}

},{"react-aria-components":"bA6Cz","tailwind-merge":"lEVAz","tailwind-variants":"dpXBU","@parcel/transformer-js/src/esmodule-helpers.js":"3OmcS"}],"ijspZ":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _tagGroup = require("vanilla-starter/TagGroup");
var _reactStately = require("react-stately");
"use client";
function Example() {
    let list = (0, _reactStately.useListData)({
        initialItems: [
            {
                id: 1,
                name: 'News'
            },
            {
                id: 2,
                name: 'Travel'
            },
            {
                id: 3,
                name: 'Gaming'
            },
            {
                id: 4,
                name: 'Shopping'
            }
        ]
    });
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _tagGroup.TagGroup), {
        label: "Categories",
        items: list.items,
        onRemove: (keys)=>list.remove(...keys),
        renderEmptyState: ()=>/*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                children: "No categories"
            }),
        children: (item)=>/*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _tagGroup.Tag), {
                children: item.name
            })
    });
}
exports.default = /*#__PURE__*/ (0, _jsxRuntime.jsx)(Example, {});

},{"react/jsx-runtime":"2Is6Z","vanilla-starter/TagGroup":"eq0FG","react-stately":"5lXoQ","@parcel/transformer-js/src/esmodule-helpers.js":"3OmcS"}],"5lXoQ":[function(require,module,exports,__globalThis) {
/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/**
 * Manages state for an immutable list data structure, and provides convenience methods to
 * update the data over time.
 */ parcelHelpers.export(exports, "useListData", ()=>useListData);
parcelHelpers.export(exports, "createListActions", ()=>createListActions);
var _react = require("react");
function useListData(options) {
    let { initialItems = [], initialSelectedKeys, getKey = (item)=>item.id ?? item.key, filter, initialFilterText = '' } = options;
    // Store both items and filteredItems in state so we can go back to the unfiltered list
    let [state, setState] = (0, _react.useState)({
        items: initialItems,
        selectedKeys: initialSelectedKeys === 'all' ? 'all' : new Set(initialSelectedKeys || []),
        filterText: initialFilterText
    });
    let filteredItems = (0, _react.useMemo)(()=>filter ? state.items.filter((item)=>filter(item, state.filterText)) : state.items, [
        state.items,
        state.filterText,
        filter
    ]);
    return {
        ...state,
        items: filteredItems,
        ...createListActions({
            getKey
        }, setState),
        getItem (key) {
            return state.items.find((item)=>getKey(item) === key);
        }
    };
}
function createListActions(opts, dispatch) {
    let { cursor, getKey } = opts;
    return {
        setSelectedKeys (selectedKeys) {
            dispatch((state)=>({
                    ...state,
                    selectedKeys
                }));
        },
        addKeysToSelection (selectedKeys) {
            dispatch((state)=>{
                if (state.selectedKeys === 'all') return state;
                if (selectedKeys === 'all') return {
                    ...state,
                    selectedKeys: 'all'
                };
                return {
                    ...state,
                    selectedKeys: new Set([
                        ...state.selectedKeys,
                        ...selectedKeys
                    ])
                };
            });
        },
        removeKeysFromSelection (selectedKeys) {
            dispatch((state)=>{
                if (selectedKeys === 'all') return {
                    ...state,
                    selectedKeys: new Set()
                };
                let selection = state.selectedKeys === 'all' ? new Set(state.items.map(getKey)) : new Set(state.selectedKeys);
                for (let key of selectedKeys)selection.delete(key);
                return {
                    ...state,
                    selectedKeys: selection
                };
            });
        },
        setFilterText (filterText) {
            dispatch((state)=>({
                    ...state,
                    filterText
                }));
        },
        insert (index, ...values) {
            dispatch((state)=>insert(state, index, ...values));
        },
        insertBefore (key, ...values) {
            dispatch((state)=>{
                let index = state.items.findIndex((item)=>getKey?.(item) === key);
                if (index === -1) {
                    if (state.items.length === 0) index = 0;
                    else return state;
                }
                return insert(state, index, ...values);
            });
        },
        insertAfter (key, ...values) {
            dispatch((state)=>{
                let index = state.items.findIndex((item)=>getKey?.(item) === key);
                if (index === -1) {
                    if (state.items.length === 0) index = 0;
                    else return state;
                }
                return insert(state, index + 1, ...values);
            });
        },
        prepend (...values) {
            dispatch((state)=>insert(state, 0, ...values));
        },
        append (...values) {
            dispatch((state)=>insert(state, state.items.length, ...values));
        },
        remove (...keys) {
            dispatch((state)=>{
                let keySet = new Set(keys);
                let items = state.items.filter((item)=>!keySet.has(getKey(item)));
                let selection = 'all';
                if (state.selectedKeys !== 'all') {
                    selection = new Set(state.selectedKeys);
                    for (let key of keys)selection.delete(key);
                }
                if (cursor == null && items.length === 0) selection = new Set();
                return {
                    ...state,
                    items,
                    selectedKeys: selection
                };
            });
        },
        removeSelectedItems () {
            dispatch((state)=>{
                if (state.selectedKeys === 'all') return {
                    ...state,
                    items: [],
                    selectedKeys: new Set()
                };
                let selectedKeys = state.selectedKeys;
                let items = state.items.filter((item)=>!selectedKeys.has(getKey(item)));
                return {
                    ...state,
                    items,
                    selectedKeys: new Set()
                };
            });
        },
        move (key, toIndex) {
            dispatch((state)=>{
                let index = state.items.findIndex((item)=>getKey(item) === key);
                if (index === -1) return state;
                let copy = state.items.slice();
                let [item] = copy.splice(index, 1);
                copy.splice(toIndex, 0, item);
                return {
                    ...state,
                    items: copy
                };
            });
        },
        moveBefore (key, keys) {
            dispatch((state)=>{
                let toIndex = state.items.findIndex((item)=>getKey(item) === key);
                if (toIndex === -1) return state;
                // Find indices of keys to move. Sort them so that the order in the list is retained.
                let keyArray = Array.isArray(keys) ? keys : [
                    ...keys
                ];
                let indices = keyArray.map((key)=>state.items.findIndex((item)=>getKey(item) === key)).sort((a, b)=>a - b);
                return move(state, indices, toIndex);
            });
        },
        moveAfter (key, keys) {
            dispatch((state)=>{
                let toIndex = state.items.findIndex((item)=>getKey(item) === key);
                if (toIndex === -1) return state;
                let keyArray = Array.isArray(keys) ? keys : [
                    ...keys
                ];
                let indices = keyArray.map((key)=>state.items.findIndex((item)=>getKey(item) === key)).sort((a, b)=>a - b);
                return move(state, indices, toIndex + 1);
            });
        },
        update (key, newValue) {
            dispatch((state)=>{
                let index = state.items.findIndex((item)=>getKey(item) === key);
                if (index === -1) return state;
                return {
                    ...state,
                    items: [
                        ...state.items.slice(0, index),
                        newValue,
                        ...state.items.slice(index + 1)
                    ]
                };
            });
        }
    };
}
function insert(state, index, ...values) {
    return {
        ...state,
        items: [
            ...state.items.slice(0, index),
            ...values,
            ...state.items.slice(index)
        ]
    };
}
function move(state, indices, toIndex) {
    // Shift the target down by the number of items being moved from before the target
    toIndex -= indices.filter((index)=>index < toIndex).length;
    let moves = indices.map((from)=>({
            from,
            to: toIndex++
        }));
    // Shift later from indices down if they have a larger index
    for(let i = 0; i < moves.length; i++){
        let a = moves[i].from;
        for(let j = i; j < moves.length; j++){
            let b = moves[j].from;
            if (b > a) moves[j].from--;
        }
    }
    // Interleave the moves so they can be applied one by one rather than all at once
    for(let i = 0; i < moves.length; i++){
        let a = moves[i];
        for(let j = moves.length - 1; j > i; j--){
            let b = moves[j];
            if (b.from < a.to) a.to++;
            else b.from++;
        }
    }
    let copy = state.items.slice();
    for (let move of moves){
        let [item] = copy.splice(move.from, 1);
        copy.splice(move.to, 0, item);
    }
    return {
        ...state,
        items: copy
    };
}

},{"react":"a1TxN","@parcel/transformer-js/src/esmodule-helpers.js":"3OmcS"}],"3rxnC":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _tagGroup = require("vanilla-starter/TagGroup");
"use client";
exports.default = /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _tagGroup.TagGroup), {
    label: "Photo categories",
    children: [
        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _tagGroup.Tag), {
            href: "https://en.wikipedia.org/wiki/Landscape_photography",
            target: "_blank",
            children: "Landscape"
        }),
        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _tagGroup.Tag), {
            href: "https://en.wikipedia.org/wiki/Portrait_photography",
            target: "_blank",
            children: "Portrait"
        }),
        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _tagGroup.Tag), {
            href: "https://en.wikipedia.org/wiki/Macro_photography",
            target: "_blank",
            children: "Macro"
        }),
        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _tagGroup.Tag), {
            href: "https://en.wikipedia.org/wiki/Night_photography",
            target: "_blank",
            children: "Night"
        }),
        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _tagGroup.Tag), {
            href: "https://en.wikipedia.org/wiki/Dualphotography",
            target: "_blank",
            children: "Dual"
        }),
        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _tagGroup.Tag), {
            href: "https://en.wikipedia.org/wiki/Golden_hour_(photography)",
            target: "_blank",
            children: "Golden Hour"
        })
    ]
});

},{"react/jsx-runtime":"2Is6Z","vanilla-starter/TagGroup":"eq0FG","@parcel/transformer-js/src/esmodule-helpers.js":"3OmcS"}],"8DQF2":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _tagGroup = require("vanilla-starter/TagGroup");
var _react = require("react");
"use client";
function Example(props) {
    let [selected, setSelected] = (0, _react.useState)(new Set());
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _tagGroup.TagGroup), {
                ...props,
                label: "Amenities",
                selectedKeys: selected,
                onSelectionChange: setSelected,
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _tagGroup.Tag), {
                        id: "laundry",
                        children: "Laundry"
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _tagGroup.Tag), {
                        id: "fitness",
                        children: "Fitness center"
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _tagGroup.Tag), {
                        id: "parking",
                        isDisabled: true,
                        children: "Parking"
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _tagGroup.Tag), {
                        id: "pool",
                        children: "Swimming pool"
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _tagGroup.Tag), {
                        id: "breakfast",
                        children: "Breakfast"
                    })
                ]
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("p", {
                children: [
                    "Current selection: ",
                    selected === 'all' ? 'all' : [
                        ...selected
                    ].join(', ')
                ]
            })
        ]
    });
}
exports.default = /*#__PURE__*/ (0, _jsxRuntime.jsx)(Example, {});

},{"react/jsx-runtime":"2Is6Z","vanilla-starter/TagGroup":"eq0FG","react":"a1TxN","@parcel/transformer-js/src/esmodule-helpers.js":"3OmcS"}],"cSREm":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _icon = require("~/src/Icon");
var _react = require("react");
"use client";
const SvgComponent = (props, ref)=>/*#__PURE__*/ (0, _jsxRuntime.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: 20,
        height: 20,
        viewBox: "0 0 20 20",
        ref: ref,
        ...props,
        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
            fill: "var(--iconPrimary, var(--lightningcss-light, rgb(41, 41, 41)) var(--lightningcss-dark, rgb(219, 219, 219)))",
            d: "m18.53 17.47-5.083-5.084C14.417 11.186 15 9.66 15 8c0-3.86-3.14-7-7-7S1 4.14 1 8s3.14 7 7 7c1.66 0 3.185-.584 4.386-1.553l5.084 5.083c.146.147.338.22.53.22s.384-.073.53-.22c.293-.293.293-.767 0-1.06M8 13.5c-3.032 0-5.5-2.468-5.5-5.5S4.968 2.5 8 2.5s5.5 2.468 5.5 5.5-2.468 5.5-5.5 5.5"
        })
    });
const ForwardRef = /*#__PURE__*/ (0, _react.forwardRef)(SvgComponent);
exports.default = /*#__PURE__*/ (0, _icon.createIcon)(ForwardRef);

},{"react/jsx-runtime":"2Is6Z","~/src/Icon":"jQAJE","react":"a1TxN","@parcel/transformer-js/src/esmodule-helpers.js":"3OmcS"}],"2370J":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _icon = require("~/src/Icon");
var _react = require("react");
"use client";
const SvgComponent = (props, ref)=>/*#__PURE__*/ (0, _jsxRuntime.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: 20,
        height: 20,
        viewBox: "0 0 20 20",
        ref: ref,
        ...props,
        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
            fill: "var(--iconPrimary, var(--lightningcss-light, rgb(41, 41, 41)) var(--lightningcss-dark, rgb(219, 219, 219)))",
            d: "M13 2.5H7c-.414 0-.75-.336-.75-.75S6.586 1 7 1h6c.414 0 .75.336.75.75s-.336.75-.75.75M16.773 14.48q-.022-.046-.05-.09L12.49 7.78V5.493h.5c.414 0 .75-.336.75-.75s-.336-.75-.75-.75h-1.25c-.414 0-.75.336-.75.75V8c0 .144.041.284.119.404l1.171 1.83-5.686 1.743 2.279-3.574c.076-.12.117-.26.117-.403V4.743c0-.414-.336-.75-.75-.75H6.99c-.414 0-.75.336-.75.75s.336.75.75.75h.5v2.288l-4.213 6.61q-.028.043-.049.09c-.351.761-.29 1.638.164 2.346C3.86 17.562 4.67 18 5.558 18h8.884c.887 0 1.697-.438 2.167-1.173.453-.708.515-1.585.164-2.347m-1.427 1.539c-.193.301-.531.481-.904.481H5.558c-.373 0-.71-.18-.904-.481-.171-.268-.2-.582-.082-.87l.779-1.222 7.768-2.383 2.31 3.604c.117.29.088.604-.083.87"
        })
    });
const ForwardRef = /*#__PURE__*/ (0, _react.forwardRef)(SvgComponent);
exports.default = /*#__PURE__*/ (0, _icon.createIcon)(ForwardRef);

},{"react/jsx-runtime":"2Is6Z","~/src/Icon":"jQAJE","react":"a1TxN","@parcel/transformer-js/src/esmodule-helpers.js":"3OmcS"}],"kmqkh":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _icon = require("~/src/Icon");
var _react = require("react");
"use client";
const SvgComponent = (props, ref)=>/*#__PURE__*/ (0, _jsxRuntime.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: 20,
        height: 20,
        viewBox: "0 0 20 20",
        ref: ref,
        ...props,
        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
            fill: "var(--iconPrimary, var(--lightningcss-light, rgb(41, 41, 41)) var(--lightningcss-dark, rgb(219, 219, 219)))",
            d: "M7.75 16.465c-.187 0-.374-.07-.52-.21-.298-.287-.308-.762-.02-1.06l4.999-5.197-4.986-5.184c-.288-.297-.279-.772.02-1.06.296-.286.774-.278 1.06.021L13.79 9.48c.28.29.28.749 0 1.039l-5.5 5.716c-.146.154-.344.23-.54.23"
        })
    });
const ForwardRef = /*#__PURE__*/ (0, _react.forwardRef)(SvgComponent);
exports.default = /*#__PURE__*/ (0, _icon.createIcon)(ForwardRef);

},{"react/jsx-runtime":"2Is6Z","~/src/Icon":"jQAJE","react":"a1TxN","@parcel/transformer-js/src/esmodule-helpers.js":"3OmcS"}],"bneuv":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _icon = require("~/src/Icon");
var _react = require("react");
"use client";
const SvgComponent = (props, ref)=>/*#__PURE__*/ (0, _jsxRuntime.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: 20,
        height: 20,
        viewBox: "0 0 20 20",
        ref: ref,
        ...props,
        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
            fill: "var(--iconPrimary, var(--lightningcss-light, rgb(41, 41, 41)) var(--lightningcss-dark, rgb(219, 219, 219)))",
            d: "M16.25 14H3.75c-.414 0-.75.336-.75.75s.336.75.75.75h12.5c.414 0 .75-.336.75-.75s-.336-.75-.75-.75M3.75 5.5h12.5c.414 0 .75-.336.75-.75S16.664 4 16.25 4H3.75c-.414 0-.75.336-.75.75s.336.75.75.75M16.25 9H3.75c-.414 0-.75.336-.75.75s.336.75.75.75h12.5c.414 0 .75-.336.75-.75S16.664 9 16.25 9"
        })
    });
const ForwardRef = /*#__PURE__*/ (0, _react.forwardRef)(SvgComponent);
exports.default = /*#__PURE__*/ (0, _icon.createIcon)(ForwardRef);

},{"react/jsx-runtime":"2Is6Z","~/src/Icon":"jQAJE","react":"a1TxN","@parcel/transformer-js/src/esmodule-helpers.js":"3OmcS"}],"1PPGS":[function(require,module,exports,__globalThis) {
/*
 * Copyright 2022 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/**
 * Provides the behavior and accessibility implementation for a list component with interactive children.
 * A grid list displays data in a single column and enables a user to navigate its contents via directional navigation keys.
 * @param props - Props for the list.
 * @param state - State for the list, as returned by `useListState`.
 * @param ref - The ref attached to the list element.
 */ parcelHelpers.export(exports, "useGridList", ()=>useGridList);
var _utils = require("@react-aria/utils");
var _utils1 = require("./utils");
var _grid = require("@react-aria/grid");
var _focus = require("@react-aria/focus");
var _selection = require("@react-aria/selection");
function useGridList(props, state, ref) {
    let { isVirtualized, keyboardDelegate, layoutDelegate, onAction, disallowTypeAhead, linkBehavior = 'action', keyboardNavigationBehavior = 'arrow', escapeKeyBehavior = 'clearSelection', shouldSelectOnPressUp } = props;
    if (!props['aria-label'] && !props['aria-labelledby']) console.warn('An aria-label or aria-labelledby prop is required for accessibility.');
    let { listProps } = (0, _selection.useSelectableList)({
        selectionManager: state.selectionManager,
        collection: state.collection,
        disabledKeys: state.disabledKeys,
        ref,
        keyboardDelegate,
        layoutDelegate,
        isVirtualized,
        selectOnFocus: state.selectionManager.selectionBehavior === 'replace',
        shouldFocusWrap: props.shouldFocusWrap,
        linkBehavior,
        disallowTypeAhead,
        autoFocus: props.autoFocus,
        escapeKeyBehavior
    });
    let id = (0, _utils.useId)(props.id);
    (0, _utils1.listMap).set(state, {
        id,
        onAction,
        linkBehavior,
        keyboardNavigationBehavior,
        shouldSelectOnPressUp
    });
    let descriptionProps = (0, _grid.useHighlightSelectionDescription)({
        selectionManager: state.selectionManager,
        hasItemActions: !!onAction
    });
    let hasTabbableChild = (0, _focus.useHasTabbableChild)(ref, {
        isDisabled: state.collection.size !== 0
    });
    let domProps = (0, _utils.filterDOMProps)(props, {
        labelable: true
    });
    let gridProps = (0, _utils.mergeProps)(domProps, {
        role: 'grid',
        id,
        'aria-multiselectable': state.selectionManager.selectionMode === 'multiple' ? 'true' : undefined
    }, // If collection is empty, make sure the grid is tabbable unless there is a child tabbable element.
    state.collection.size === 0 ? {
        tabIndex: hasTabbableChild ? -1 : 0
    } : listProps, descriptionProps);
    if (isVirtualized) {
        gridProps['aria-rowcount'] = state.collection.size;
        gridProps['aria-colcount'] = 1;
    }
    (0, _grid.useGridSelectionAnnouncement)({}, state);
    return {
        gridProps
    };
}

},{"@react-aria/utils":[["filterDOMProps","3upVm"],["mergeProps","aNvcY"],["useId","jbI4Y"]],"./utils":"aJkqW","@react-aria/grid":[["useGridSelectionAnnouncement","deyzk"],["useHighlightSelectionDescription","eO4Xt"]],"@react-aria/focus":"eSQu0","@react-aria/selection":"ldksp","@parcel/transformer-js/src/esmodule-helpers.js":"3OmcS"}],"aJkqW":[function(require,module,exports,__globalThis) {
/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "listMap", ()=>listMap);
parcelHelpers.export(exports, "getRowId", ()=>getRowId);
parcelHelpers.export(exports, "normalizeKey", ()=>normalizeKey);
const listMap = new WeakMap();
function getRowId(state, key) {
    let { id } = listMap.get(state) ?? {};
    if (!id) throw new Error('Unknown list');
    return `${id}-${normalizeKey(key)}`;
}
function normalizeKey(key) {
    if (typeof key === 'string') return key.replace(/\s*/g, '');
    return '' + key;
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"3OmcS"}],"deyzk":[function(require,module,exports,__globalThis) {
/*
 * Copyright 2022 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "useGridSelectionAnnouncement", ()=>useGridSelectionAnnouncement);
var _liveAnnouncer = require("@react-aria/live-announcer");
// @ts-ignore
var _json = require("../intl/*.json");
var _jsonDefault = parcelHelpers.interopDefault(_json);
var _react = require("react");
var _i18N = require("@react-aria/i18n");
var _utils = require("@react-aria/utils");
function useGridSelectionAnnouncement(props, state) {
    let { getRowText = (key)=>state.collection.getTextValue?.(key) ?? state.collection.getItem(key)?.textValue } = props;
    let stringFormatter = (0, _i18N.useLocalizedStringFormatter)((0, _jsonDefault.default), '@react-aria/grid');
    // Many screen readers do not announce when items in a grid are selected/deselected.
    // We do this using an ARIA live region.
    let selection = state.selectionManager.rawSelection;
    let lastSelection = (0, _react.useRef)(selection);
    let announceSelectionChange = (0, _react.useCallback)(()=>{
        if (!state.selectionManager.isFocused || selection === lastSelection.current) {
            lastSelection.current = selection;
            return;
        }
        let addedKeys = diffSelection(selection, lastSelection.current);
        let removedKeys = diffSelection(lastSelection.current, selection);
        // If adding or removing a single row from the selection, announce the name of that item.
        let isReplace = state.selectionManager.selectionBehavior === 'replace';
        let messages = [];
        if (state.selectionManager.selectedKeys.size === 1 && isReplace) {
            let firstKey = state.selectionManager.selectedKeys.keys().next().value;
            if (firstKey != null && state.collection.getItem(firstKey)) {
                let currentSelectionText = getRowText(firstKey);
                if (currentSelectionText) messages.push(stringFormatter.format('selectedItem', {
                    item: currentSelectionText
                }));
            }
        } else if (addedKeys.size === 1 && removedKeys.size === 0) {
            let firstKey = addedKeys.keys().next().value;
            if (firstKey != null) {
                let addedText = getRowText(firstKey);
                if (addedText) messages.push(stringFormatter.format('selectedItem', {
                    item: addedText
                }));
            }
        } else if (removedKeys.size === 1 && addedKeys.size === 0) {
            let firstKey = removedKeys.keys().next().value;
            if (firstKey != null && state.collection.getItem(firstKey)) {
                let removedText = getRowText(firstKey);
                if (removedText) messages.push(stringFormatter.format('deselectedItem', {
                    item: removedText
                }));
            }
        }
        // Announce how many items are selected, except when selecting the first item.
        if (state.selectionManager.selectionMode === 'multiple') {
            if (messages.length === 0 || selection === 'all' || selection.size > 1 || lastSelection.current === 'all' || lastSelection.current?.size > 1) messages.push(selection === 'all' ? stringFormatter.format('selectedAll') : stringFormatter.format('selectedCount', {
                count: selection.size
            }));
        }
        if (messages.length > 0) (0, _liveAnnouncer.announce)(messages.join(' '));
        lastSelection.current = selection;
    }, [
        selection,
        state.selectionManager.selectedKeys,
        state.selectionManager.isFocused,
        state.selectionManager.selectionBehavior,
        state.selectionManager.selectionMode,
        state.collection,
        getRowText,
        stringFormatter
    ]);
    // useUpdateEffect will handle using useEffectEvent, no need to stabilize anything on this end
    (0, _utils.useUpdateEffect)(()=>{
        if (state.selectionManager.isFocused) announceSelectionChange();
        else {
            // Wait a frame in case the collection is about to become focused (e.g. on mouse down).
            let raf = requestAnimationFrame(announceSelectionChange);
            return ()=>cancelAnimationFrame(raf);
        }
    }, [
        selection,
        state.selectionManager.isFocused
    ]);
}
function diffSelection(a, b) {
    let res = new Set();
    if (a === 'all' || b === 'all') return res;
    for (let key of a.keys())if (!b.has(key)) res.add(key);
    return res;
}

},{"@react-aria/live-announcer":"3nbSW","../intl/*.json":"hdtsN","react":"a1TxN","@react-aria/i18n":"7lxyl","@react-aria/utils":"ekc37","@parcel/transformer-js/src/esmodule-helpers.js":"3OmcS"}],"hdtsN":[function(require,module,exports,__globalThis) {
const _temp0 = require("549f76802fea3145");
const _temp1 = require("99e711b09beafbae");
const _temp2 = require("d822d49a9f50f8f2");
const _temp3 = require("62716c14c7ab3b19");
const _temp4 = require("f993c3bd895f4a55");
const _temp5 = require("87ba517e0d2284cb");
const _temp6 = require("9959e6866268baa2");
const _temp7 = require("a5d29cf49321ccbd");
const _temp8 = require("d4a263166a379f7");
const _temp9 = require("adb7cef23c3e7915");
const _temp10 = require("b85e649d4f0c8fa0");
const _temp11 = require("669dff92f11c15b2");
const _temp12 = require("56a3bfdc95a3af99");
const _temp13 = require("92bd2be1c2e45a26");
const _temp14 = require("ac7b779e60091ebf");
const _temp15 = require("7350c7eb30e615e3");
const _temp16 = require("3260bfccae03c79c");
const _temp17 = require("e01abdb08e203859");
const _temp18 = require("5551bd334b751799");
const _temp19 = require("a555cf93e0917ba2");
const _temp20 = require("f519d273a2594a58");
const _temp21 = require("2ab2dc559350f8cb");
const _temp22 = require("aa7f9e578044416a");
const _temp23 = require("7828f13f1de12a9c");
const _temp24 = require("b776cb1c3588783c");
const _temp25 = require("b2c037c8f99b4b1d");
const _temp26 = require("3656d7d096e21208");
const _temp27 = require("64de068ffd5db517");
const _temp28 = require("6afb03c6be24a7db");
const _temp29 = require("fac4d0e10b154d11");
const _temp30 = require("5207f24182fa30c9");
const _temp31 = require("6c177c75c6c9f015");
const _temp32 = require("1c95bec940ff1fe8");
const _temp33 = require("736ec483e330f374");
module.exports = {
    "ar-AE": _temp0,
    "bg-BG": _temp1,
    "cs-CZ": _temp2,
    "da-DK": _temp3,
    "de-DE": _temp4,
    "el-GR": _temp5,
    "en-US": _temp6,
    "es-ES": _temp7,
    "et-EE": _temp8,
    "fi-FI": _temp9,
    "fr-FR": _temp10,
    "he-IL": _temp11,
    "hr-HR": _temp12,
    "hu-HU": _temp13,
    "it-IT": _temp14,
    "ja-JP": _temp15,
    "ko-KR": _temp16,
    "lt-LT": _temp17,
    "lv-LV": _temp18,
    "nb-NO": _temp19,
    "nl-NL": _temp20,
    "pl-PL": _temp21,
    "pt-BR": _temp22,
    "pt-PT": _temp23,
    "ro-RO": _temp24,
    "ru-RU": _temp25,
    "sk-SK": _temp26,
    "sl-SI": _temp27,
    "sr-SP": _temp28,
    "sv-SE": _temp29,
    "tr-TR": _temp30,
    "uk-UA": _temp31,
    "zh-CN": _temp32,
    "zh-TW": _temp33
};

},{"549f76802fea3145":"ctpKo","99e711b09beafbae":"ctpKo","d822d49a9f50f8f2":"ctpKo","62716c14c7ab3b19":"ctpKo","f993c3bd895f4a55":"ctpKo","87ba517e0d2284cb":"ctpKo","9959e6866268baa2":"3Tpgz","a5d29cf49321ccbd":"ctpKo","d4a263166a379f7":"ctpKo","adb7cef23c3e7915":"ctpKo","b85e649d4f0c8fa0":"ctpKo","669dff92f11c15b2":"ctpKo","56a3bfdc95a3af99":"ctpKo","92bd2be1c2e45a26":"ctpKo","ac7b779e60091ebf":"ctpKo","7350c7eb30e615e3":"ctpKo","3260bfccae03c79c":"ctpKo","e01abdb08e203859":"ctpKo","5551bd334b751799":"ctpKo","a555cf93e0917ba2":"ctpKo","f519d273a2594a58":"ctpKo","2ab2dc559350f8cb":"ctpKo","aa7f9e578044416a":"ctpKo","7828f13f1de12a9c":"ctpKo","b776cb1c3588783c":"ctpKo","b2c037c8f99b4b1d":"ctpKo","3656d7d096e21208":"ctpKo","64de068ffd5db517":"ctpKo","6afb03c6be24a7db":"ctpKo","fac4d0e10b154d11":"ctpKo","5207f24182fa30c9":"ctpKo","6c177c75c6c9f015":"ctpKo","1c95bec940ff1fe8":"ctpKo","736ec483e330f374":"ctpKo"}],"3Tpgz":[function(require,module,exports,__globalThis) {
module.exports = {
    "deselectedItem": (args)=>`${args.item} not selected.`,
    "select": `Select`,
    "selectedCount": (args, formatter)=>`${formatter.plural(args.count, {
            "=0": `No items selected`,
            one: ()=>`${formatter.number(args.count)} item selected`,
            other: ()=>`${formatter.number(args.count)} items selected`
        })}.`,
    "selectedAll": `All items selected.`,
    "selectedItem": (args)=>`${args.item} selected.`,
    "longPressToSelect": `Long press to enter selection mode.`
};

},{}],"eO4Xt":[function(require,module,exports,__globalThis) {
/*
 * Copyright 2021 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/**
 * Computes the description for a grid selectable collection.
 * @param props
 */ parcelHelpers.export(exports, "useHighlightSelectionDescription", ()=>useHighlightSelectionDescription);
// @ts-ignore
var _json = require("../intl/*.json");
var _jsonDefault = parcelHelpers.interopDefault(_json);
var _utils = require("@react-aria/utils");
var _interactions = require("@react-aria/interactions");
var _i18N = require("@react-aria/i18n");
var _react = require("react");
function useHighlightSelectionDescription(props) {
    let stringFormatter = (0, _i18N.useLocalizedStringFormatter)((0, _jsonDefault.default), '@react-aria/grid');
    let modality = (0, _interactions.useInteractionModality)();
    // null is the default if the user hasn't interacted with the table at all yet or the rest of the page
    let shouldLongPress = (modality === 'pointer' || modality === 'virtual' || modality == null) && typeof window !== 'undefined' && 'ontouchstart' in window;
    let interactionDescription = (0, _react.useMemo)(()=>{
        let selectionMode = props.selectionManager.selectionMode;
        let selectionBehavior = props.selectionManager.selectionBehavior;
        let message;
        if (shouldLongPress) message = stringFormatter.format('longPressToSelect');
        return selectionBehavior === 'replace' && selectionMode !== 'none' && props.hasItemActions ? message : undefined;
    }, [
        props.selectionManager.selectionMode,
        props.selectionManager.selectionBehavior,
        props.hasItemActions,
        stringFormatter,
        shouldLongPress
    ]);
    let descriptionProps = (0, _utils.useDescription)(interactionDescription);
    return descriptionProps;
}

},{"../intl/*.json":"hdtsN","@react-aria/utils":"h4qnk","@react-aria/interactions":"dkfxW","@react-aria/i18n":"7lxyl","react":"a1TxN","@parcel/transformer-js/src/esmodule-helpers.js":"3OmcS"}],"fNHH4":[function(require,module,exports,__globalThis) {
/*
 * Copyright 2022 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/**
 * Provides the behavior and accessibility implementation for a row in a grid list.
 * @param props - Props for the row.
 * @param state - State of the parent list, as returned by `useListState`.
 * @param ref - The ref attached to the row element.
 */ parcelHelpers.export(exports, "useGridListItem", ()=>useGridListItem);
var _utils = require("@react-aria/utils");
var _focus = require("@react-aria/focus");
var _utils1 = require("./utils");
var _react = require("react");
var _interactions = require("@react-aria/interactions");
var _selection = require("@react-aria/selection");
var _i18N = require("@react-aria/i18n");
const EXPANSION_KEYS = {
    'expand': {
        ltr: 'ArrowRight',
        rtl: 'ArrowLeft'
    },
    'collapse': {
        ltr: 'ArrowLeft',
        rtl: 'ArrowRight'
    }
};
function useGridListItem(props, state, ref) {
    // Copied from useGridCell + some modifications to make it not so grid specific
    let { node, isVirtualized } = props;
    // let stringFormatter = useLocalizedStringFormatter(intlMessages, '@react-aria/gridlist');
    let { direction } = (0, _i18N.useLocale)();
    let { onAction, linkBehavior, keyboardNavigationBehavior, shouldSelectOnPressUp } = (0, _utils1.listMap).get(state);
    let descriptionId = (0, _utils.useSlotId)();
    // We need to track the key of the item at the time it was last focused so that we force
    // focus to go to the item when the DOM node is reused for a different item in a virtualizer.
    let keyWhenFocused = (0, _react.useRef)(null);
    let focus = ()=>{
        // Don't shift focus to the row if the active element is a element within the row already
        // (e.g. clicking on a row button)
        if (ref.current !== null && (keyWhenFocused.current != null && node.key !== keyWhenFocused.current || !ref.current?.contains(document.activeElement))) (0, _focus.focusSafely)(ref.current);
    };
    let treeGridRowProps = {};
    let hasChildRows = props.hasChildItems;
    let hasLink = state.selectionManager.isLink(node.key);
    if (node != null && 'expandedKeys' in state) {
        // TODO: ideally node.hasChildNodes would be a way to tell if a row has child nodes, but the row's contents make it so that value is always
        // true...
        let children = state.collection.getChildren?.(node.key);
        hasChildRows = hasChildRows || [
            ...children ?? []
        ].length > 1;
        if (onAction == null && !hasLink && state.selectionManager.selectionMode === 'none' && hasChildRows) onAction = ()=>state.toggleKey(node.key);
        let isExpanded = hasChildRows ? state.expandedKeys.has(node.key) : undefined;
        let setSize = 1;
        if (node.level > 0 && node?.parentKey != null) {
            let parent = state.collection.getItem(node.parentKey);
            if (parent) {
                // siblings must exist because our original node exists
                let siblings = state.collection.getChildren?.(parent.key);
                setSize = [
                    ...siblings
                ].filter((row)=>row.type === 'item').length;
            }
        } else setSize = [
            ...state.collection
        ].filter((row)=>row.level === 0 && row.type === 'item').length;
        treeGridRowProps = {
            'aria-expanded': isExpanded,
            'aria-level': node.level + 1,
            'aria-posinset': node?.index + 1,
            'aria-setsize': setSize
        };
    }
    let { itemProps, ...itemStates } = (0, _selection.useSelectableItem)({
        selectionManager: state.selectionManager,
        key: node.key,
        ref,
        isVirtualized,
        shouldSelectOnPressUp: props.shouldSelectOnPressUp || shouldSelectOnPressUp,
        onAction: onAction || node.props?.onAction ? (0, _utils.chain)(node.props?.onAction, onAction ? ()=>onAction(node.key) : undefined) : undefined,
        focus,
        linkBehavior
    });
    let onKeyDownCapture = (e)=>{
        if (!e.currentTarget.contains(e.target) || !ref.current || !document.activeElement) return;
        let walker = (0, _focus.getFocusableTreeWalker)(ref.current);
        walker.currentNode = document.activeElement;
        if ('expandedKeys' in state && document.activeElement === ref.current) {
            if (e.key === EXPANSION_KEYS['expand'][direction] && state.selectionManager.focusedKey === node.key && hasChildRows && !state.expandedKeys.has(node.key)) {
                state.toggleKey(node.key);
                e.stopPropagation();
                return;
            } else if (e.key === EXPANSION_KEYS['collapse'][direction] && state.selectionManager.focusedKey === node.key && hasChildRows && state.expandedKeys.has(node.key)) {
                state.toggleKey(node.key);
                e.stopPropagation();
                return;
            }
        }
        switch(e.key){
            case 'ArrowLeft':
                if (keyboardNavigationBehavior === 'arrow') {
                    // Find the next focusable element within the row.
                    let focusable = direction === 'rtl' ? walker.nextNode() : walker.previousNode();
                    if (focusable) {
                        e.preventDefault();
                        e.stopPropagation();
                        (0, _focus.focusSafely)(focusable);
                        (0, _utils.scrollIntoViewport)(focusable, {
                            containingElement: (0, _utils.getScrollParent)(ref.current)
                        });
                    } else {
                        // If there is no next focusable child, then return focus back to the row
                        e.preventDefault();
                        e.stopPropagation();
                        if (direction === 'rtl') {
                            (0, _focus.focusSafely)(ref.current);
                            (0, _utils.scrollIntoViewport)(ref.current, {
                                containingElement: (0, _utils.getScrollParent)(ref.current)
                            });
                        } else {
                            walker.currentNode = ref.current;
                            let lastElement = last(walker);
                            if (lastElement) {
                                (0, _focus.focusSafely)(lastElement);
                                (0, _utils.scrollIntoViewport)(lastElement, {
                                    containingElement: (0, _utils.getScrollParent)(ref.current)
                                });
                            }
                        }
                    }
                }
                break;
            case 'ArrowRight':
                if (keyboardNavigationBehavior === 'arrow') {
                    let focusable = direction === 'rtl' ? walker.previousNode() : walker.nextNode();
                    if (focusable) {
                        e.preventDefault();
                        e.stopPropagation();
                        (0, _focus.focusSafely)(focusable);
                        (0, _utils.scrollIntoViewport)(focusable, {
                            containingElement: (0, _utils.getScrollParent)(ref.current)
                        });
                    } else {
                        e.preventDefault();
                        e.stopPropagation();
                        if (direction === 'ltr') {
                            (0, _focus.focusSafely)(ref.current);
                            (0, _utils.scrollIntoViewport)(ref.current, {
                                containingElement: (0, _utils.getScrollParent)(ref.current)
                            });
                        } else {
                            walker.currentNode = ref.current;
                            let lastElement = last(walker);
                            if (lastElement) {
                                (0, _focus.focusSafely)(lastElement);
                                (0, _utils.scrollIntoViewport)(lastElement, {
                                    containingElement: (0, _utils.getScrollParent)(ref.current)
                                });
                            }
                        }
                    }
                }
                break;
            case 'ArrowUp':
            case 'ArrowDown':
                // Prevent this event from reaching row children, e.g. menu buttons. We want arrow keys to navigate
                // to the row above/below instead. We need to re-dispatch the event from a higher parent so it still
                // bubbles and gets handled by useSelectableCollection.
                if (!e.altKey && ref.current.contains(e.target)) {
                    e.stopPropagation();
                    e.preventDefault();
                    ref.current.parentElement?.dispatchEvent(new KeyboardEvent(e.nativeEvent.type, e.nativeEvent));
                }
                break;
        }
    };
    let onFocus = (e)=>{
        keyWhenFocused.current = node.key;
        if (e.target !== ref.current) {
            // useSelectableItem only handles setting the focused key when
            // the focused element is the row itself. We also want to
            // set the focused key when a child element receives focus.
            // If focus is currently visible (e.g. the user is navigating with the keyboard),
            // then skip this. We want to restore focus to the previously focused row
            // in that case since the list should act like a single tab stop.
            if (!(0, _interactions.isFocusVisible)()) state.selectionManager.setFocusedKey(node.key);
            return;
        }
    };
    let onKeyDown = (e)=>{
        if (!e.currentTarget.contains(e.target) || !ref.current || !document.activeElement) return;
        switch(e.key){
            case 'Tab':
                if (keyboardNavigationBehavior === 'tab') {
                    // If there is another focusable element within this item, stop propagation so the tab key
                    // is handled by the browser and not by useSelectableCollection (which would take us out of the list).
                    let walker = (0, _focus.getFocusableTreeWalker)(ref.current, {
                        tabbable: true
                    });
                    walker.currentNode = document.activeElement;
                    let next = e.shiftKey ? walker.previousNode() : walker.nextNode();
                    if (next) e.stopPropagation();
                }
        }
    };
    let syntheticLinkProps = (0, _utils.useSyntheticLinkProps)(node.props);
    let linkProps = itemStates.hasAction ? syntheticLinkProps : {};
    // TODO: re-add when we get translations and fix this for iOS VO
    // let rowAnnouncement;
    // if (onAction) {
    //   rowAnnouncement = stringFormatter.format('hasActionAnnouncement');
    // } else if (hasLink) {
    //   rowAnnouncement = stringFormatter.format('hasLinkAnnouncement', {
    //     link: node.props.href
    //   });
    // }
    let rowProps = (0, _utils.mergeProps)(itemProps, linkProps, {
        role: 'row',
        onKeyDownCapture,
        onKeyDown,
        onFocus,
        // 'aria-label': [(node.textValue || undefined), rowAnnouncement].filter(Boolean).join(', '),
        'aria-label': node.textValue || undefined,
        'aria-selected': state.selectionManager.canSelectItem(node.key) ? state.selectionManager.isSelected(node.key) : undefined,
        'aria-disabled': state.selectionManager.isDisabled(node.key) || undefined,
        'aria-labelledby': descriptionId && node.textValue ? `${(0, _utils1.getRowId)(state, node.key)} ${descriptionId}` : undefined,
        id: (0, _utils1.getRowId)(state, node.key)
    });
    if (isVirtualized) {
        let { collection } = state;
        let nodes = [
            ...collection
        ];
        // TODO: refactor ListCollection to store an absolute index of a node's position?
        rowProps['aria-rowindex'] = nodes.find((node)=>node.type === 'section') ? [
            ...collection.getKeys()
        ].filter((key)=>collection.getItem(key)?.type !== 'section').findIndex((key)=>key === node.key) + 1 : node.index + 1;
    }
    let gridCellProps = {
        role: 'gridcell',
        'aria-colindex': 1
    };
    // TODO: should isExpanded and hasChildRows be a item state that gets returned by the hook?
    return {
        rowProps: {
            ...(0, _utils.mergeProps)(rowProps, treeGridRowProps)
        },
        gridCellProps,
        descriptionProps: {
            id: descriptionId
        },
        ...itemStates
    };
}
function last(walker) {
    let next = null;
    let last = null;
    do {
        last = walker.lastChild();
        if (last) next = last;
    }while (last);
    return next;
}

},{"@react-aria/utils":[["chain","ij7eS"],["getScrollParent","1Tu7U"],["mergeProps","aNvcY"],["scrollIntoViewport","1lzpw"],["useSlotId","jbI4Y"],["useSyntheticLinkProps","4FGnT"]],"@react-aria/focus":[["focusSafely","2ysUy"],["getFocusableTreeWalker","9oPIl"]],"./utils":"aJkqW","react":"a1TxN","@react-aria/interactions":"dkfxW","@react-aria/selection":"cJdJS","@react-aria/i18n":"4k4z8","@parcel/transformer-js/src/esmodule-helpers.js":"3OmcS"}]},[], null, "parcelRequire7f0c", {})

//# sourceMappingURL=TagGroup.c8f4ac35.js.map
